<template>
  <div>
    <router-link :to="{ name: 'image-upload', params: { slug: $route.params.id }}">New Image</router-link>
    <el-table
      :data="images"
      :empty-text="'No Category available'"
      :default-sort = "{prop: 'id', order: 'ascending'}"
      style="width: 100%">
      <el-table-column
        label="Image"
        prop="file_path"
        sortable>
        <template slot-scope="scope">
          <img :src="scope.row.file_path" alt="" height="50" width="50">
        </template>
      </el-table-column>
      <el-table-column
        prop="file_path_thumbnail"
        label="Thumbnail">
        <template slot-scope="scope">
          <img :src="scope.row.file_path_thumbnail" alt="" height="50" width="50">
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="Operations"
        width="120">
        <template slot-scope="scope">
          <el-button v-if="!scope.row.file_path.includes('/item/cart.png')" @click="deleteImage(scope.row.id)" type="text" size="small">
            <i class="text-3xl text-red-500 el-icon-delete-solid"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>

</template>

<script>
export default {
  name: 'DeleteImage',
  computed: {
    images() {
      return this.$store.state.InventoryModule.Products.images;
    },
  },
  methods: {
    deleteImage(imageId) {
      this.$confirm('This will permanently delete this image, Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('InventoryModule/Products/deleteItemImage', { productId: this.$route.params.id, imageId });
          this.$notify.success({
            title: 'Success',
            message: 'Image successfully deleted',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
